import React from "react";
import {MDBBtn, MDBContainer, MDBFooter, MDBIcon} from "mdb-react-ui-kit";

const Footer = () => {
    return <MDBFooter className='bg-dark text-center text-white' style={{marginTop:"25%"}}>


        <div className='text-center p-3' style={{ backgroundColor: "#2A3E4E" }}>
            Tous droits réservés ® Amala Klep Kremmel
            <a className='text-white' href='https://mdbootstrap.com/'>

            </a>
        </div>
    </MDBFooter>;
};
export default Footer;